const WORD_REPLACEMENTS = {
  aji: 'aj\u00ed',
  ajies: 'aj\u00edes',
  anis: 'an\u00eds',
  arandano: 'ar\u00e1ndano',
  arandanos: 'ar\u00e1ndanos',
  atun: 'at\u00fan',
  atunes: 'atunes',
  azucar: 'az\u00facar',
  batata: 'batata',
  batatas: 'batatas',
  berenjena: 'berenjena',
  berenjenas: 'berenjenas',
  brocoli: 'br\u00f3coli',
  cafe: 'caf\u00e9',
  cafes: 'caf\u00e9s',
  camaron: 'camar\u00f3n',
  camarones: 'camarones',
  canelon: 'canel\u00f3n',
  canelones: 'canelones',
  canonigo: 'can\u00f3nigo',
  canonigos: 'can\u00f3nigos',
  castana: 'casta\u00f1a',
  castanas: 'casta\u00f1as',
  cebollin: 'ceboll\u00edn',
  cebollines: 'cebollines',
  champinon: 'champi\u00f1\u00f3n',
  champinones: 'champi\u00f1ones',
  chia: 'ch\u00eda',
  choclo: 'choclo',
  choclos: 'choclos',
  coliflor: 'coliflor',
  datil: 'd\u00e1til',
  datiles: 'd\u00e1tiles',
  duraznon: 'durazn\u00f3n',
  duraznones: 'duraznones',
  espinaca: 'espinaca',
  espinacas: 'espinacas',
  fideos: 'fideos',
  frambuesa: 'frambuesa',
  frambuesas: 'frambuesas',
  frijol: 'frijol',
  frijoles: 'frijoles',
  garbanzo: 'garbanzo',
  garbanzos: 'garbanzos',
  jengibre: 'jengibre',
  jalapeno: 'jalape\u00f1o',
  jalapenos: 'jalape\u00f1os',
  jamon: 'jam\u00f3n',
  kiwi: 'kiwi',
  kion: 'ki\u00f3n',
  lacteo: 'l\u00e1cteo',
  lacteos: 'l\u00e1cteos',
  lamina: 'l\u00e1mina',
  laminas: 'l\u00e1minas',
  lasana: 'lasa\u00f1a',
  lasanas: 'lasa\u00f1as',
  lenteja: 'lenteja',
  lentejas: 'lentejas',
  limon: 'lim\u00f3n',
  limones: 'limones',
  maiz: 'ma\u00edz',
  mani: 'man\u00ed',
  maniqui: 'maniqu\u00ed',
  maracuya: 'maracuy\u00e1',
  maracuyaes: 'maracuy\u00e1s',
  melon: 'mel\u00f3n',
  melones: 'melones',
  milanesa: 'milanesa',
  milanesas: 'milanesas',
  morron: 'morr\u00f3n',
  morrones: 'morrones',
  mozzarella: 'mozzarella',
  nandu: '\u00f1and\u00fa',
  nandues: '\u00f1and\u00faes',
  papin: 'pap\u00edn',
  papines: 'papines',
  pimenton: 'piment\u00f3n',
  pinon: 'pi\u00f1\u00f3n',
  pinones: 'pi\u00f1ones',
  pina: 'pi\u00f1a',
  pinas: 'pi\u00f1as',
  platano: 'pl\u00e1tano',
  platanos: 'pl\u00e1tanos',
  pure: 'pur\u00e9',
  pures: 'pur\u00e9s',
  queso: 'queso',
  quinoa: 'quinoa',
  rabano: 'r\u00e1bano',
  rabanos: 'r\u00e1banos',
  ravioli: 'ravioli',
  raviolis: 'raviolis',
  repollo: 'repollo',
  rinon: 'ri\u00f1\u00f3n',
  rinones: 'ri\u00f1ones',
  salmon: 'salm\u00f3n',
  sandia: 'sand\u00eda',
  sesamo: 's\u00e9samo',
  soya: 'soya',
  te: 't\u00e9',
  tomate: 'tomate',
  tomates: 'tomates',
  tuna: 'tuna',
  zanahoria: 'zanahoria',
  zanahorias: 'zanahorias'
};

const LOWERCASE_CONNECTORS = new Set([
  'a',
  'al',
  'con',
  'de',
  'del',
  'e',
  'en',
  'la',
  'las',
  'o',
  'por',
  'para',
  'sin',
  'u',
  'y'
]);

function removeAccents(value) {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

function normalizeWord(word) {
  const lower = word.toLowerCase();
  const normalized = removeAccents(lower);
  return WORD_REPLACEMENTS[normalized] || lower;
}

function titleCaseSpanishWord(word, index) {
  if (!word) return word;
  const normalized = normalizeWord(word);
  if (index > 0 && LOWERCASE_CONNECTORS.has(normalized)) {
    return normalized;
  }
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

export function formatIngredientName(value) {
  const raw = String(value || '').trim().replace(/\s+/g, ' ');
  if (!raw) return '';

  const parts = raw.split(/(\s+|-|\/|\(|\)|,)/);
  let wordIndex = 0;

  return parts
    .map((part) => {
      if (!part || /^(\s+|-|\/|\(|\)|,)$/.test(part)) {
        return part;
      }
      if (!/[a-zA-Z\u00c0-\u017f]/.test(part)) {
        return part;
      }
      const formatted = titleCaseSpanishWord(part, wordIndex);
      wordIndex += 1;
      return formatted;
    })
    .join('');
}

